import { UnitType } from '@mitsubishi/shared/data-access';

export namespace NewsActions {
  export class Load {
    public static readonly type = '[News] Load news with filters';
  }

  export class SetNewsType {
    static readonly type = '[News] Set news type';
    constructor(public type: number | null) {}
  }

  export class SetSearchText {
    static readonly type = '[News] Set search text';
    constructor(public searchText: string | null) {}
  }

  export class SetSearchTags {
    static readonly type = '[News] Set search tags';
    constructor(public tags: string[]) {}
  }

  export class LoadTags {
    static readonly type = '[News] Get news tags';
  }

  export class ResetNewsFilters {
    static readonly type = '[News] Reset news filters';
  }

  export class SetUnitFilter {
    static readonly type = '[News] Set unit filter';
    constructor(
      public unitId: string,
      public unitType: UnitType
    ) {}
  }
}
